<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form form">
        <div
          class="form__input-wrapper form__input-wrapper--textarea"
          :class="{ error: $v.form.importantToYouDescription.$anyError, disabled: form.importantToYouSkip }"
        >
          <label for="is-description-import" class="form__label uk-hidden"
            >Co jest dla Ciebie ważne?
          </label>
          <textarea
            class="form-input"
            name="is-description-import"
            id="is-description-import"
            @input="event => delayTouchCounterComposition($v.form, 'importantToYouDescription', event.target.value)"
            cols="30"
          />
          <span class="form__error-message form__error-message--no-label">
            <template v-if="!$v.form.importantToYouDescription.minLength">
              {{ validationMessage.minLength }}</template
            >
            <template v-if="!$v.form.importantToYouDescription.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
        <div
          class="
            brief-step__skip-step
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="importantToYouSkip"
            type="checkbox"
            name="importantToYouSkip"
            :value="form.importantToYouSkip"
            v-model.trim="form.importantToYouSkip"
            @change="delayTouch($v.form)"
          />
          <label for="importantToYouSkip" class="form__label">
            Pominąć ten krok?
          </label>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';

export default {
  name: 'ImportetToYou',
  components: { BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      // eslint-disable-next-line operator-linebreak
      'Nie jesteśmy Alfą i Omegą. Być może nie zapytaliśmy o rzeczy, które są dla Ciebie ' +
      'istotne. Podziel się nimi tutaj.',
    form: {
      importantToYouDescription: '',
      importantToYouSkip: false,
    },
  }),
  validations() {
    if (this.form.importantToYouSkip) {
      return {
        form: {
          importantToYouDescription: {},
        },
      };
    }
    return {
      form: {
        importantToYouDescription: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
};
</script>

<style scoped lang="scss">
.disabled {
  textarea {
    background-color: rgb(235, 235, 235);
    border-color: transparent;
    pointer-events: none;
  }
}
</style>
